import * as React from 'react';
import {
  ScrollView,
  StyleSheet,
  Text,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native';

import PrimaryButton from '../../../../shared/buttons/PrimaryButton';
import CheckButton from '../../../../shared/forms/CheckButton';

interface Props {
  onPress: () => void;
}

const ServiceExplanationStep2: React.FC<Props> = props => {
  const {onPress} = props;
  const [checked, setChecked] = React.useState(false);
  const onPressCheck = React.useCallback(() => {
    setChecked(!checked);
  }, [checked]);
  return (
    <ScrollView>
      <View style={styles.container}>
        <Text style={styles.message}>
          お仕事の報酬や権利の扱いについては、{'\n'}
          オファーごとに異なります。{'\n'}
          オファー内容をよく読み、理解した上で{'\n'}
          応募するようにしてください。
        </Text>
        <CheckButton
          style={styles.checkButton}
          checked={checked}
          onPress={onPressCheck}>
          理解した
        </CheckButton>
        <PrimaryButton disabled={!checked} onPress={onPress}>
          次へ
        </PrimaryButton>
      </View>
    </ScrollView>
  );
};

export default React.memo(ServiceExplanationStep2);

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    borderTopColor: '#efefef',
    borderTopWidth: 1,
    flex: 1,
    alignItems: 'center',
    padding: 24,
  } as ViewStyle,
  message: {
    color: '#383838',
    fontSize: 14,
    textAlign: 'center',
    marginVertical: 8,
  } as TextStyle,
  checkButton: {
    width: 160,
    justifyContent: 'center',
    marginTop: 24,
    marginBottom: 16,
  } as ViewStyle,
});
